export default {
    CodigoDoisFatores: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "codigo-dois-fatores"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CodigoDoisFatores.js
// module id = n+pw
// module chunks = 13